export default {
  'pages.businessAppMarket.title': '應用市場',
  'pages.businessAppMarket.subtitle':
    '探索適合團隊的業務應用，依需求開通並集中使用。',
  'pages.businessAppMarket.backToCenter': '返回應用',
  'pages.businessAppMarket.myApps': '我的應用',
  'pages.businessAppMarket.refresh': '重新整理',
  'pages.businessAppMarket.searchLabel': '應用名稱',
  'pages.businessAppMarket.searchPlaceholder': '搜尋應用名稱或描述',
  'pages.businessAppMarket.search': '搜尋',
  'pages.businessAppMarket.pricingLabel': '價格類型',
  'pages.businessAppMarket.all': '全部',
  'pages.businessAppMarket.free': '免費',
  'pages.businessAppMarket.paid': '付費',
  'pages.businessAppMarket.categoryLabel': '應用分類',
  'pages.businessAppMarket.allCategories': '全部分類',
  'pages.businessAppMarket.resetFilters': '重設篩選',
  'pages.businessAppMarket.resultCount': '共 {count} 個應用',
  'pages.businessAppMarket.loadError': '應用市場載入失敗',
  'pages.businessAppMarket.loadErrorDescription':
    '暫時無法取得應用資訊，請稍後重試。',
  'pages.businessAppMarket.retry': '重試',
  'pages.businessAppMarket.empty': '尚無上架應用',
  'pages.businessAppMarket.filteredEmpty': '找不到符合條件的應用',
  'pages.businessAppMarket.emptyDescription':
    '請調整篩選條件，或稍後查看新上架應用。',
  'pages.businessAppMarket.details': '查看詳情',
  'pages.businessAppMarket.detailTitle': '應用詳情',
  'pages.businessAppMarket.description': '應用介紹',
  'pages.businessAppMarket.developer': '開發者',
  'pages.businessAppMarket.unknownDeveloper': '未提供開發者資訊',
  'pages.businessAppMarket.noDescription': '尚無應用介紹',
  'pages.businessAppMarket.certification': '認證資訊',
  'pages.businessAppMarket.official': '官方認證',
  'pages.businessAppMarket.unverified': '未認證',
  'pages.businessAppMarket.category': '應用分類',
  'pages.businessAppMarket.uncategorized': '未分類',
  'pages.businessAppMarket.price': '價格',
  'pages.businessAppMarket.contactRequired': '聯絡營運團隊',
  'pages.businessAppMarket.contactReason':
    '未設定銷售價格、採用按席位計價或開通方式尚未明確，請聯絡營運團隊。',
  'pages.businessAppMarket.freeActivate': '免費開通',
  'pages.businessAppMarket.paidActivate': '購買開通',
  'pages.businessAppMarket.open': '開啟應用',
  'pages.businessAppMarket.unavailableUrl': '尚未設定可用的存取網址',
  'pages.businessAppMarket.installed': '已開通',
  'pages.businessAppMarket.previewImages': '應用預覽',
  'pages.businessAppMarket.previewAlt': '{name}預覽圖 {index}',
  'pages.businessAppMarket.noPreview': '尚無預覽圖片',
  'pages.businessAppMarket.close': '關閉',
  'pages.businessAppMarket.missingApp': '找不到此應用',
  'pages.businessAppMarket.missingAppDescription':
    '目前目錄結果中未找到此應用，請搜尋應用名稱後重試。應用也可能已下架。',
  'pages.businessAppMarket.clearDetails': '返回市場清單',
  'pages.businessAppMarket.detailLoadError': '應用詳情載入失敗',
  'pages.businessAppMarket.detailLoading': '正在載入應用詳情',
  'pages.businessAppMarket.confirmFreeTitle': '確認免費開通',
  'pages.businessAppMarket.confirmPaidTitle': '確認購買開通',
  'pages.businessAppMarket.confirmFreeDescription':
    '將為目前企業開通「{name}」。',
  'pages.businessAppMarket.confirmPaidDescription':
    '將為目前企業建立「{name}」的購買訂單，價格為 {price}。',
  'pages.businessAppMarket.confirm': '確認',
  'pages.businessAppMarket.cancel': '取消',
  'pages.businessAppMarket.activateSuccess': '應用開通成功',
  'pages.businessAppMarket.alreadyActive': '應用已開通',
  'pages.businessAppMarket.activateError': '應用開通失敗，請稍後重試。',
  'pages.businessAppMarket.orderError': '建立訂單失敗，請稍後重試。',
  'pages.businessAppMarket.confirmationError':
    '無法確認開通條件，請重新整理後重試。',
  'pages.businessAppMarket.contextChanged':
    '企業或登入狀態已變更，請重新整理後再操作。',
  'pages.businessAppMarket.sessionRequired': '請登入並選擇企業後繼續。',
};
